<syn-page-loader [loading]="loading"></syn-page-loader>

<ng-container *ngIf="!loading && !sageSubscriptions?.length">
    <div class="syn-message syn-box--info">
        Il n'y a aucun abonnement associé à <strong>{{ businessCode }}</strong> dans Sage.
    </div>
</ng-container>

<ng-container *ngIf="!loading && sageSubscriptions?.length">
    <div *ngFor="let subscr of sageSubscriptions">
        <syn-subscription fxFlex class="syn--padding-bottom" [subscription]="subscr"></syn-subscription>
    </div>
</ng-container>
